// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import star from '../../../../images/star.svg';

const RatingItem = ({
  classes,
  comment,
  rate,
}) => {


  return (
    <div className={classes.mainContainer}>
      <div className={classes.commentContainer}>
        <p className={classes.text}>{parse(comment)}</p>
      </div>
      <div className={classes.rateContainer}>
        {[...Array(rate)].map(() => (
          <div className={classes.imageContainer}>
            <img className={classes.image} src={star} alt={'star'} />
          </div>
        ))}
      </div>
    </div>
  );
};

RatingItem.propTypes = {
  classes: PropTypes.object,
  comment: PropTypes.string,
  rate: PropTypes.number,
};

RatingItem.defaultProps = {
  classes: {},
  comment: '',
  rate: 0,
};


export default withStyles(styles)(RatingItem);
